import { ExperimentBase } from "./experiment-base.js";

export class NavigationManager {
  private burgerButton: HTMLElement;
  private navPanel: HTMLElement;
  private navOverlay: HTMLElement;
  private navItems: NodeListOf<HTMLElement>;
  private sections: NodeListOf<HTMLElement>;
  private currentExperiment: string = "notes";
  private experiments: Map<string, ExperimentBase> = new Map();

  public registerExperiment(id: string, experiment: ExperimentBase): void {
    this.experiments.set(id, experiment);
    experiment.initialize();
  }

  constructor() {
    this.burgerButton = document.getElementById("burgerButton")!;
    this.navPanel = document.getElementById("navPanel")!;
    this.navOverlay = document.getElementById("navOverlay")!;
    this.navItems = document.querySelectorAll(".nav-item");
    this.sections = document.querySelectorAll(".experiment-section");
    
    this.setupEventListeners();
    this.setupRouting();
    
    // Check URL path on initial load
    const path = window.location.pathname.substring(1) || window.location.hash.substring(1);
    const validExperiments = ['notes', 'gameshow', 'versus', 'safety-qa', 'pong', 'murdnd'];
    const experimentId = validExperiments.includes(path) ? path : 'notes';
    
    this.switchExperiment(experimentId, false);
  }

  private setupEventListeners(): void {
    this.burgerButton?.addEventListener("click", () => this.toggleMenu());
    this.navOverlay?.addEventListener("click", () => this.closeMenu());
    
    this.navItems.forEach(item => {
      item.addEventListener("click", () => {
        const experiment = item.dataset.experiment;
        if (experiment) {
          this.switchExperiment(experiment, true);
          this.closeMenu();
        }
      });
    });
  }

  private setupRouting(): void {
    // Handle browser back/forward buttons
    window.addEventListener('popstate', (event) => {
      const path = window.location.pathname.substring(1) || window.location.hash.substring(1);
      if (path) {
        this.switchExperiment(path, false);
      }
    });
  }

  private toggleMenu(): void {
    const isActive = this.navPanel?.classList.contains("active");
    if (isActive) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  private openMenu(): void {
    this.burgerButton?.classList.add("active");
    this.navPanel?.classList.add("active");
    this.navOverlay?.classList.add("active");
  }

  private closeMenu(): void {
    this.burgerButton?.classList.remove("active");
    this.navPanel?.classList.remove("active");
    this.navOverlay?.classList.remove("active");
  }

  public switchExperiment(experimentId: string, updateUrl: boolean = true): void {
    // Scroll to top of page
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    // Update URL if requested
    if (updateUrl) {
      const newUrl = `/${experimentId}`;
      window.history.pushState({ experiment: experimentId }, '', newUrl);
    }
    
    // Hide all sections
    this.sections.forEach(section => {
      section.style.display = "none";
    });
    
    // Show selected section
    const targetSection = document.getElementById(`${experimentId}-section`);
    if (targetSection) {
      targetSection.style.display = "block";
    }
    
    // Update nav active state
    this.navItems.forEach(item => {
      if (item.dataset.experiment === experimentId) {
        item.classList.add("active");
      } else {
        item.classList.remove("active");
      }
    });
    
    // Deactivate previous experiment
    const prevExperiment = this.experiments.get(this.currentExperiment);
    if (prevExperiment) {
      prevExperiment.deactivate();
    }
    
    this.currentExperiment = experimentId;
    
    // Activate new experiment
    const newExperiment = this.experiments.get(experimentId);
    if (newExperiment) {
      newExperiment.activate();
    }
  }
}